/**
 * @author       matthew@zumper.com (Matthew Talamini)
 * @copyright    Copyright (c) 2022, Zumper
 * @description  SweetDealPercentContainer
 */

import type { State } from '@zcode/state-type'
import { connect } from 'react-redux'
import { selectPriceDataRecentAverages } from '../../../../../../modules/priceData/selectors/index'

import { SweetDealPercent } from './SweetDealPercent'

const mapStateToProps = (state: State) => {
  return {
    recentAverages: selectPriceDataRecentAverages(state),
  }
}

export const SweetDealPercentContainer = connect(mapStateToProps)(SweetDealPercent)
